import _ from "lodash";
import { PriceSearchFormHydrator } from "../../../umbilical_hocs";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { Formik, Form } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { DateTime } from "luxon";
import { DatepickerField } from "../inputGroup/helpers";
import {
  chooseDateForActivity,
  retrieveDatesByPickup,
} from "../../../api/activities";
import { useSelector } from "react-redux";
import { Placeholder } from "rsuite";
import { activitiesErrorMsgs, onError } from "../../../errors";
import { toast } from "react-toastify";
import { ReactSelectField } from "../inputGroup/helpers";
import { Button } from "../../common/Button";
import jssVariables from "../../../jss_setup";
import { modalGenericStyles } from "../../../jss_setup/modals";
import { animateScroll as scroll } from "react-scroll";
import { NoScrollContext } from "../../../context";
import { Icon } from "@iconify/react";
import { Price } from "../../common/Price";

const ActSearchFormStyles = createUseStyles({
  ...modalGenericStyles,
  underlay: (props) => ({
    display: "grid",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0, .5)",
    backdropFilter: "blur(5px)",
    ...(props?.customStyles?.underlay ?? {}),
  }),
  actPriceSearchFormContr: (props) => ({
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    position: "fixed",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 9999,
    width: "70%",
    ...(props?.customStyles?.actPriceSearchFormContr ?? {}),
  }),
  closeIcon: (props) => ({
    color: "white",
    fontSize: "xx-large",
    justifySelf: "end",
    cursor: "pointer",
    ...(props?.customStyles?.closeIcon ?? {}),
  }),
  ActPriceSearchForm: (props) => ({
    display: props.showForm ? "grid" : "none",
    gridGap: jssVariables.normal_gap,
    width: `calc(100% - ${jssVariables.half_gap})`,
    borderRadius: jssVariables.border_radius,
    boxShadow: jssVariables.shadows.normalShadow,
    background: "white",
    padding: `calc(${jssVariables.normal_gap} * 2)`,
    marginRight: jssVariables.half_gap,
    justifyItems: "center",
    ...(props?.customStyles?.ActPriceSearchForm ?? {}),
  }),
  overlay: (props) => ({
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    background: jssVariables.colors.background.dark,
    display: "grid",
    placeItems: "center",
    borderRadius: jssVariables.normal_gap,
    ...(props?.customStyles?.overlay ?? {}),
  }),
  priceContr: (props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, max-content)",
    gridGap: jssVariables.normal_gap,
    alignItems: "baseline",
    fontSize: "medium",
    ...(props?.customStyles?.priceContr ?? {}),
  }),
  loadingIcon: (props) => ({
    fontSize: "xxx-large",
    color: jssVariables.colors.base_color,
    ...(props?.customStyles?.loadingIcon ?? {}),
  }),
  form: (props) => ({
    display: "grid",
    gridGap: jssVariables.double_gap,
    ...(props?.customStyles?.form ?? {}),
  }),
  inputGroup: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ...(props?.customStyles?.inputGroup ?? {}),
  }),
  label: (props) => ({
    fontSize: "medium",
    fontWeight: "bold",
    ...(props?.customStyles?.label ?? {}),
  }),
  datepicker: (props) => ({
    width: "100%",
    padding: jssVariables.normal_gap,
    borderRadius: "5px",
    fontSize: "large",
    border: `2px solid ${jssVariables.colors.base_color}`,
    ...(props?.customStyles?.datepicker ?? {}),
  }),
  travelDate: (props) => ({
    border: `2px solid ${jssVariables.colors.base_color}`,
    background: "none",
    padding: `calc(${jssVariables.normal_gap} /2)`,
    transition: "background .3s, color .3s",
    cursor: "pointer",
    borderRadius: "5px",
    fontWeight: "bold",
    fontSize: "small",
    "&:hover": {
      background: jssVariables.colors.base_color,
      color: "white",
    },
    ...(props?.customStyles?.travelDate ?? {}),
  }),
  selectedTravelDate: (props) => ({
    background: jssVariables.colors.base_color,
    color: "white",
    ...(props?.customStyles?.selectedTravelDate ?? {}),
  }),
  paxPicker: (props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, max-content)",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    fontSize: "large",
    ...(props?.customStyles?.paxPicker ?? {}),
  }),
  pax: (props) => ({
    ...(props?.customStyles?.pax ?? {}),
  }),
  paxBtn: (props) => ({
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    ...(props?.customStyles?.paxBtn ?? {}),
  }),
  actions: (props) => ({
    justifySelf: "center",
    ...(props?.customStyles?.actions ?? {}),
  }),
  searchBtn: (props) => ({
    fontWeight: "bold",
    fontSize: "larger",
    padding: `calc(${jssVariables.normal_gap} / 2)`,
    borderRadius: "5px",
    background: jssVariables.colors.base_color,
    ...(props?.customStyles?.searchBtn ?? {}),
  }),
  cancelBtnContainer: (props) => ({
    display: "grid",
    ...(props?.customStyles?.cancelBtnContainer ?? {}),
  }),
  cancelBtn: (props) => ({
    display: "block",
    fontSize: "larger",
    fontWeight: "bold",
    padding: `calc(${jssVariables.normal_gap} / 2)`,
    borderRadius: "5px",
    ...(props?.customStyles?.cancelBtn ?? {}),
  }),
  price: (props) => ({
    fontSize: "large",
    ...(props?.customStyles?.price ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    underlay: (props) => ({
      display: "none",
      ...(props?.customStyles?.underlay?.smallscreen ?? {}),
    }),
    closeIcon: (props) => ({
      display: "none",
      ...(props?.customStyles?.closeIcon?.smallscreen ?? {}),
    }),
    actPriceSearchFormContr: (props) => ({
      width: "100%",
      ...(props?.customStyles?.actPriceSearchFormContr?.smallscreen ?? {}),
    }),
    ActPriceSearchForm: (props) => ({
      display: "grid",
      right: jssVariables.normal_gap,
      width: "17rem",
      left: "unset",
      marginRight: jssVariables.normal_gap,
      position: "absolute",
      ...(props?.customStyles?.ActPriceSearchForm?.smallscreen ?? {}),
    }),
    priceContr: (props) => ({
      ...(props?.customStyles?.priceContr?.smallscreen ?? {}),
    }),
    actions: (props) => ({
      gridTemplateColumns: "1fr",
      ...(props?.customStyles?.actions?.smallscreen ?? {}),
    }),
    cancelBtnContainer: (props) => ({
      display: "none",
      ...(props?.customStyles?.cancelBtnContainer?.smallscreen ?? {}),
    }),
    cancelBtn: (props) => ({
      ...(props?.customStyles?.cancelBtn?.smallscreen ?? {}),
    }),
    price: (props) => ({
      fontSize: "medium",
      ...(props?.customStyles?.price?.smallscreen ?? {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    ActPriceSearchForm: (props) => ({
      ...(props?.customStyles?.ActPriceSearchForm?.bigscreen ?? {}),
    }),
    price: (props) => ({
      fontSize: "x-large",
      ...(props?.customStyles?.price?.bigscreen ?? {}),
    }),
  },
});
var ActPriceSearchForm = ({
  price,
  onCancel,
  showForm,
  activity,
  onSetShowModal,
  setBookingData,
  pickUpAndDates,
  setPickUpAndDates,
}) => {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pickupUid, setPickupUid] = useState("");
  const { t } = useContext(TranslationContext);
  const noScrollContext = useContext(NoScrollContext);

  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({ type, brand, objName: "ActPriceSearchForm" });
  const classes = ActSearchFormStyles({ customStyles, showForm });

  const { search_form } = useSelector((state) => ({
    search_form: state.ActivitySearchForm,
  }));

  async function onChooseDateForActivity({
    search_session_id,
    activity_uid,
    date,
    pickup_code,
  }) {
    const dateLocal = DateTime.fromISO(date).toLocal().toFormat("yyyy-MM-dd");
    onSetShowModal(true);
    const result = await chooseDateForActivity({
      search_session_id,
      activity_uid,
      date: dateLocal,
      pickup_code,
      onError: (error) => {
        const errorType = _.lowerCase(error?.response?.data?.message ?? "");
        var msg = "";
        if (errorType.includes("date")) {
          msg = activitiesErrorMsgs.detailView.no_availability_for_date;
        } else if (errorType.includes("session")) {
          msg = activitiesErrorMsgs.detailView.no_availability;
        }
        toast.warning(msg, { duration: 5000 });
      },
    });

    if (!result) onSetShowModal(false);

    if (result)
      setBookingData({ schedules: result.schedules, date: date, pickup_code });
  }

  async function onGetDatesByPickup() {
    setLoading(true);
    if (pickupUid) {
      const result = await retrieveDatesByPickup({
        activity_uid: activity.uid,
        search_session_id: search_form.search_session_id,
        pickup_code: pickupUid,
      });
      if (!result.dates.length) {
        setStep(0);
        onError(activitiesErrorMsgs.detailView.no_date_for_pickup_point);
      }
      if (result) {
        setLoading(false);
        setPickUpAndDates({ pickup_point: pickupUid, dates: result.dates });
      }
    }
  }

  useEffect(() => {
    if (step === 0) return;
    onGetDatesByPickup();
  }, [step]);

  var amount = price.value_per_person;
  if (!amount) amount = price.value;

  return (
    showForm && (
      <React.Fragment>
        <div className={classes.underlay}></div>
        <div className={classes.actPriceSearchFormContr}>
          <Icon
            icon="ic:baseline-close"
            className={classes.closeIcon}
            onClick={(e) => {
              e.preventDefault();
              onCancel();
            }}
          />
          <div className={classes.ActPriceSearchForm}>
            <div className={classes.priceContr}>
              {t("from") + " "}
              <Price
                price={amount}
                currency={price.currency}
                customStyles={customStyles}
              />
              {" /" + t("person")}
            </div>
            <Formik
              initialValues={{
                pickupPoint: null,
                date: pickUpAndDates.length
                  ? DateTime.fromISO(pickUpAndDates.dates[0].date).toISO()
                  : search_form.date_from
                  ? DateTime.fromISO(search_form.date_from).toISO()
                  : null,
              }}
              validate={async (values) => {
                if (activity.pickup_point_required) {
                  const pickup_uid = activity.pickup_points.find(
                    (pickup) => pickup.name === values.pickupPoint.value
                  ).uid;
                  setPickupUid(pickup_uid);
                }
              }}
              onSubmit={async (values) => {
                const search_session_id = search_form?.search_session_id ?? "";
                var dataForAPI = {
                  search_session_id,
                  activity_uid: activity.uid,
                  date: values.date,
                };
                if (activity.pickup_point_required) {
                  dataForAPI = {
                    ...dataForAPI,
                    pickup_code: activity.pickup_points.find(
                      (pickup) => (pickup.name = values.pickupPoint.value)
                    ).uid,
                  };
                }
                scroll.scrollToTop();
                noScrollContext.toggleNoScroll(true);
                onChooseDateForActivity({ ...dataForAPI });
              }}>
              {({ values }) => (
                <Form className={classes.form}>
                  <React.Fragment>
                    {activity.pickup_point_required ? (
                      <React.Fragment>
                        {step === 0 ? (
                          <ReactSelectField
                            label={t("pickupPoint")}
                            name="pickupPoint"
                            options={activity.pickup_points.map((pickup) => ({
                              value: pickup.name,
                              label: pickup.name,
                            }))}
                            customStyles={{
                              ...customStyles,
                              inputGroup: { width: "10rem" },
                            }}
                            isMulti={false}
                            closeMenuOnSelect={true}
                            placeholder="----"
                          />
                        ) : (
                          <React.Fragment>
                            {loading ? (
                              <Placeholder.Paragraph
                                rows={2}
                                active
                                className={classes.placeholderParagraph}
                              />
                            ) : (
                              values.pickupPoint &&
                              pickUpAndDates.dates.length > 0 && (
                                <DatepickerField
                                  name="date"
                                  label={`${t("date")}:`}
                                  dateFormat="MMM d, yyyy"
                                  withPortal={true}
                                  minDate={DateTime.fromISO(
                                    pickUpAndDates.dates[0].date
                                  ).toISO()}
                                  maxDate={DateTime.fromISO(
                                    pickUpAndDates.dates[
                                      pickUpAndDates.dates.length - 1
                                    ].date
                                  ).toISO()}
                                  customStyles={customStyles}
                                  filterDate={(date) =>
                                    pickUpAndDates.dates
                                      .map((date) => date.date)
                                      .includes(
                                        DateTime.fromJSDate(date).toISODate()
                                      )
                                  }
                                />
                              )
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : (
                      <DatepickerField
                        name="date"
                        label="date"
                        dateFormat="MMM d, yyyy"
                        withPortal={true}
                        minDate={DateTime.fromISO(
                          search_form.date_from
                        ).toISO()}
                        maxDate={DateTime.fromISO(search_form.date_to).toISO()}
                        customStyles={{
                          ...customStyles,
                          inputGroup: {
                            gridTemplateColumns: "max-content 60%",
                            gridGap: jssVariables.normal_gap,
                            alignItems: "center",
                          },
                        }}
                        filterDate={(date) =>
                          activity.availability
                            .map((avail) => avail.date)
                            .includes(DateTime.fromJSDate(date).toISODate())
                        }
                      />
                    )}
                  </React.Fragment>
                  {/* <div className={classes.inputGroup}> */}

                  {/* </div> */}
                  <div className={classes.actions}>
                    {activity.pickup_point_required && step === 0 ? (
                      <React.Fragment>
                        <Button
                          text={t("nextStep")}
                          bold={true}
                          onClick={(e) => {
                            if (!values.pickupPoint) {
                              toast.warning(
                                activitiesErrorMsgs.detailView
                                  .select_pick_up_point,
                                { duration: 5000 }
                              );
                              return;
                            }
                            e.preventDefault();
                            setStep(step + 1);
                          }}
                        />
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <Button
                          id="actGetPrices"
                          text={t("getPrices")}
                          type="submit"
                          bold={true}
                        />
                      </React.Fragment>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </React.Fragment>
    )
  );
};
ActPriceSearchForm.defaultProps = {
  price: {},
  versions: [],
  showForm: false,
  activity_uid: "",
  pickUpAndDates: {},
};
ActPriceSearchForm.propTypes = {
  activity: PropTypes.object.isRequired,
  price: PropTypes.object.isRequired,
  showForm: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  activity_uid: PropTypes.string.isRequired,
  onSetShowModal: PropTypes.func.isRequired,
  setBookingData: PropTypes.func.isRequired,
  pickUpAndDates: PropTypes.object.isRequired,
  setPickUpAndDates: PropTypes.func.isRequired,
};
ActPriceSearchForm = PriceSearchFormHydrator(ActPriceSearchForm, "MI");
export { ActPriceSearchForm };
